import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from '@app/_shared/_helpers/global.helper';
import { MenuService } from '@app/admin/_services/menu.service';
import * as _ from "underscore"

@Component({
  selector: 'dashlayout-sidebar-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  MenuRoutes = []
  constructor(private globalHelper:GlobalHelper,private menuService:MenuService) {}

  ngOnInit() {
    this.init();}

  init(){
    this.MenuRoutes = this.menuService.getMenu();
    this.verifyCanView(this.MenuRoutes);
  }
  verifyCanView(routes){
    _.each(routes, (route) => {
      route.canView = this.canView(route);
      if(route.childrens)
      this.verifyCanView(route.childrens)
    });
  }
  toggle(route) {
    console.log('toggle', route)
    // console.log(this.routes[i]);
    if (route.childrens && route.childrens.length) {
      route.toggle = !route.toggle;
    }
  }
  canView(item) {
    // let department;
    // if(item.departments && this.departmentService.selectedItem){
    //   department = _.find(item.departments, (d) => {
    //     return  d == this.departmentService.selectedItem.department
    //   });
    // }

    // if (this.currentUser?.admin) return (item.departments && department) || !item.departments;
    // console.log('canView', item, item.roles, this.currentUser?.roles);


    //todo add roles
    // if (this.currentUser) return (item.departments && department) || !item.departments;


    const role = this.globalHelper.hasRoles(item.roles)

    // console.log("canView",role,this.currentUser?.roles)

    return (!item.roles || role) //  && ((item.departments && department) || !item.departments);
  }
  isParentActualPage(item){
    // console.log("isParentActualPage",window.location.pathname,item.link,window?.location.pathname.indexOf(item.link?.[0]))
    return window?.location.pathname.indexOf(item.link?.[0]) > -1
  }
}
